import controller from './app.controller';
import template from './app.template.html';
import './app.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/app.component.js